import React, { useEffect } from 'react';
import Footer from '@/components/Footer';
import LoginForm from './form';
import styles from './style/index.module.less';
import { WarpGrid } from '@/components/WarpGrid';
function Login() {
  useEffect(() => {
    document.body.setAttribute('arco-theme', 'light');
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content-inner']
  }, /*#__PURE__*/React.createElement(LoginForm, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Footer, null))), /*#__PURE__*/React.createElement("div", {
    className: styles.warpGrid
  }, /*#__PURE__*/React.createElement(WarpGrid, null)));
}
Login.displayName = 'LoginPage';
export default Login;